import React, { Component } from "react";
import { Spin, Modal } from "antd";
import { generateCmsData, generateGrowthData } from "../../services";
import DemoDetailView from "./DemoDetailView";
import { showSuccessNotification, showErrorNotification } from "../../helpers";
export default class DemoDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDetailModal: false,
      contentType: null,
      userPhoneNumber: null,
      isProcessing: false
    };
  }

  /**
   * @function openDetailModal
   * @param key
   * @desc this will open demo detail model
   */
  toggleDetailModal = () => {
    this.setState({
      openDetailModal: !this.state.openDetailModal
    });
  };

  handleButtonClick = type => {
    this.setState({
      contentType: type,
      openDetailModal: true
    });
  };

  handleInputChange = e => {
    const { value } = e.currentTarget;
    this.setState({
      userPhoneNumber: value
    });
  };

  /**
   * @function generateData
   * @param key
   * @desc this will ogenerate data
   */
  generateData = () => {
    const { contentType, userPhoneNumber } = this.state;

    let apiResponse = null;
    this.setState({
      isProcessing: true
    });
    if (contentType === "cms") {
      apiResponse = generateCmsData(userPhoneNumber);
    } else {
      apiResponse = generateGrowthData(userPhoneNumber);
    }
    apiResponse.then(response => {
      this.setState({
        isProcessing: false
      });
      if (response.data.success === true) {
        showSuccessNotification("Data successfully generated");
        this.setState({
          openDetailModal: false,
          userPhoneNumber: null,
          contentType: null
        });
      } else {
        showErrorNotification("Something went wrong try again");
      }
    });
  };

  render() {
    const { openDetailModal, userPhoneNumber, isProcessing } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <DemoDetailView
          toggleDetailModal={this.toggleDetailModal}
          openDetailModal={openDetailModal}
          userPhoneNumber={userPhoneNumber}
          handleButtonClick={this.handleButtonClick}
          generateData={this.generateData}
          handleInputChange={this.handleInputChange}
          isProcessing={isProcessing}
        />
      </Spin>
    );
  }
}
